import { RuleShow } from './RuleShow';
import { RuleEdit } from './RuleEdit';
import { RuleCreate } from './RuleCreate';
import { RuleList } from './RuleList';

export default {
    list: RuleList,
    show: RuleShow,
    edit: RuleEdit,
    create: RuleCreate,
};
